export class UserRegiester {
    username: string;
    password: string;
    retype_password: string;
    mobile: string;
    address: string = "";
}


// WEBPACK FOOTER //
// ./src/app/shared/registeration/user-registeration.ts